import environment from 'environment';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import EffectUtility from '../../utilities/EffectUtility';
import HandshakeModel from './models/HandshakeModel';

export default class HandshakeEffect {
    public static async requestValidateHandshake(params?: any): Promise<HandshakeModel | HttpErrorResponseModel> {
        let endpoint: string = '';

        switch (params.app) {
            case 'login':
                endpoint = environment.api.handshakeLogin;
                break;
            case 'recipient':
                endpoint = environment.api.handshakeRecipient;
                break;
            default:
                endpoint = environment.api.handshakeChallenge;
                break;
        }
        if (params.app === 'login') {
            endpoint = environment.api.handshakeLogin;
        }

        return EffectUtility.getToModel<HandshakeModel>(HandshakeModel, endpoint);
    }
}
